import { Vehicle } from '@/core/domain/branches/models/branch.model';
import { Component, Input, ViewEncapsulation } from '@angular/core';
@Component({
    selector: 'fe-upgrade-promotion-summary',
    templateUrl: './upgrade-promotion-summary.component.html',
    styleUrls: ['./upgrade-promotion-summary.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class UpgradePromotionSummaryComponent {
    @Input() vehicle?: Vehicle;
    @Input() vehicleUpgrade?: Vehicle;
}
